export const CREATE_SUB_JOB_RECEIVE = 'CREATE_SUB_JOB_RECEIVE';
export const GET_SUB_JOB_RECEIVES = 'GET_SUB_JOB_RECEIVES';
export const SUB_JOB_RECEIVE_REQUEST = 'SUB_JOB_RECEIVE_REQUEST';
export const UPDATE_SUB_JOB_RECEIVE = 'UPDATE_SUB_JOB_RECEIVE';
export const DELETE_SUB_JOB_RECEIVE = 'DELETE_SUB_JOB_RECEIVE';
export const SUB_JOB_RECEIVE_REQUEST_FAILURE = 'SUB_JOB_RECEIVE_REQUEST_FAILURE';